"use strict";
var $ = require("../internals/export");
var codeAt = require("../internals/string-multibyte").codeAt;
$({ target: "String", proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});
